import { render } from "./ImagesView.vue?vue&type=template&id=4a4d9817"
import script from "./ImagesView.vue?vue&type=script&lang=js"
export * from "./ImagesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__